import { createApp } from 'vue';
import App from './App.vue';
import './index.css';
import { createPinia } from 'pinia';
import router from './router';
import '@mdi/font/css/materialdesignicons.css';
import 'material-icons/iconfont/material-icons.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { Table, Icon, Config } from '@oruga-ui/oruga-next';
import '@oruga-ui/oruga-next/dist/oruga-full-vars.css';
import './assets/oruga-tailwind.css';
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import cn from '@/locales/cn.json'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';


//util / downloaded component to use it anywhere
import TitleWStar from "@/components/shared/util/TitleWStar.vue";
import EggLabelList from "@/components/shared/util/EggLabelList.vue";
import EggDescription from "@/components/shared/util/EggDescription.vue";
import ImageDescriptionList from "@/components/shared/util/ImageDescriptionList.vue";
import LandingPage from "@/components/shared/util/LandingPage.vue";
import BannerDescription from "@/components/shared/util/BannerDescription.vue";
import CollapseGroup from "@/components/shared/util/CollapseGroup.vue";
import ButtonUtil from "@/components/shared/util/ButtonUtil.vue";

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  globalInjection: true,
  messages: {
    en,
    cn,
  }
})

const app = createApp(
  App,
);

// Pinia
app.use(createPinia());
// Router
app.use(router);
// Toastification config
app.use(Toast, {
  position: 'bottom-right',
  timeout: 5000,
  pauseOnFocusLoss: false,
});
// Oruga UI
app.use(Table);
app.use(Icon);
app.use(Config, {
  checkbox: {
    checkClass: 'checkbox',
    checkCheckedClass: 'checkbox-checked',
  },
  pagination: {
    linkCurrentClass: 'pagination-link',
  },
  table: {
    thClass: 'table-th',
    thCurrentSortClass: 'table-th-current-sort',
    thSortableClass: 'table-sortable',
    paginationWrapperClass: 'table-pagination-wrapper',
  },
});


app.use(i18n);
app.component("TitleWStar", TitleWStar); // global registration - can be used anywhere+
app.component("EggLabelList", EggLabelList); // global registration - can be used anywhere
app.component("EggDescription", EggDescription); // global registration - can be used anywhere
app.component("ImageDescriptionList", ImageDescriptionList); // global registration - can be used anywhere
app.component("LandingPage", LandingPage); // global registration - can be used anywhere
app.component("BannerDescription", BannerDescription); // global registration - can be used anywhere
app.component("CollapseGroup", CollapseGroup); // global registration - can be used anywhere
app.component("ButtonUtil", ButtonUtil); // global registration - can be used anywhere
app.component('vue-cookie-accept-decline', VueCookieAcceptDecline);
app.mount('#app');